export default __webpack_public_path__ + "media/color/safe-0cf7e8e7.svg";